import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

export interface PendingNavigation {
  conversationId: string;
  isTemp: boolean;
  tempData?: {
    type: string;
    studentId?: string;
    displayName: string;
    photoUrl: string | null;
    initials: string;
    designation?: string;
    roomName?: string | null;
  };
}

@Injectable({ providedIn: 'root' })
export class ChatNavigationService {
  private pending: PendingNavigation | null = null;
  private tabSubject = new Subject<'student' | 'staff'>();
  tabChange$ = this.tabSubject.asObservable();

  constructor(private router: Router) {}

  setTabNavigation(tab: 'student' | 'staff'): void {
    this.tabSubject.next(tab);
  }

  navigateTo(conversationId: string, tempData?: PendingNavigation['tempData']): void {
    this.pending = { conversationId, isTemp: !!tempData, tempData };
    this.router.navigate(['/communication']);
  }

  getPending(): PendingNavigation | null {
    return this.pending;
  }

  clearPending(): void {
    this.pending = null;
  }
}
